var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebarEmptyState"},[_c('p',{staticClass:"sidebarEmptyState__text"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }